import { cn } from "@-/com.npmjs.cn";
import type { ComponentProps, ReactNode } from "react";

// 16px text keeps iOS Safari from zooming the page when a field gains focus.
const WEBSITE_FORM_CONTROL_CLASS_NAME =
  "block w-full rounded-xs border border-black/15 bg-white px-3.5 py-3 text-base text-black outline-none transition-[border-color,box-shadow] duration-200 placeholder:text-black/35 focus:border-website-accent focus:ring-3 focus:ring-website-accent/20";

/** A labelled form field: the label above its control and an optional hint below. */
export function WebsiteFormField({
  children,
  hint,
  label,
}: {
  children: ReactNode;
  hint?: string;
  label: string;
}) {
  return (
    <label className="flex flex-col gap-2">
      <span className="text-sm font-semibold">{label}</span>
      {children}
      {hint === undefined ? null : <span className="text-xs text-current/50">{hint}</span>}
    </label>
  );
}

export function WebsiteInput({ className, ...props }: ComponentProps<"input">) {
  return <input className={cn(WEBSITE_FORM_CONTROL_CLASS_NAME, className)} {...props} />;
}

export function WebsiteTextarea({ className, ...props }: ComponentProps<"textarea">) {
  return (
    <textarea
      className={cn(WEBSITE_FORM_CONTROL_CLASS_NAME, "min-h-32 resize-y", className)}
      {...props}
    />
  );
}
